module.exports = __webpack_public_path__ + "img/success.320f2df4.svg";